import { render, staticRenderFns } from "./BaseTaxForm.vue?vue&type=template&id=5805d5c8&"
import script from "./BaseTaxForm.vue?vue&type=script&lang=js&"
export * from "./BaseTaxForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports